const GITHUB_URL = "https://github.com/zachspiel";
const LINKEDIN_URL = "https://www.linkedin.com/in/zachary-spielberger/";

export { GITHUB_URL, LINKEDIN_URL };
